/**
* Removes the background image of the element defined by selector and replaces
* it with the corresponing spin.js preset. Returns jquery object (element).
*/
s.showLoadingSpinner = function showLoadingSpinner(selector, preset){
  return $(selector).addClass('state-loading').spin(preset);
};


/**
* Sets up spin.js presets.
*/
s.callOnReady(function setupLoadingSpinner(){
  $.fn.spin.presets.white = {
    lines: 11,
    length: 15,
    width: 17,
    radius: 57,
    scale: 0.15,
    color: '#fff',
    opacity: 0.25,
    speed: 2,
    trail: 60,
    className: 'spinner',
    top: '',  // set by CSS, according to the use case.
    left: '', // set by CSS, according to the use case.
    hwaccel: true,
    position: '' // set by CSS, according to the use case.
  };

  // Only change is color
  $.fn.spin.presets.grey = {
    lines: 11,
    length: 15,
    width: 17,
    radius: 57,
    scale: 0.15,
    color: '#6b6b68',
    opacity: 0.25,
    speed: 2,
    trail: 60,
    className: 'spinner',
    top: '',  // set by CSS, according to the use case.
    left: '',  // set by CSS, according to the use case.
    hwaccel: true,
    position: ''  // set by CSS, according to the use case.
  };
});


/**
* Changes a stateful buttons state to the one specified and back again. It
* stops any Spinners attached with spin.js and adjusts the classes.
* NOTE: The styling of classes must be done with CSS.
*/
s.statefulButtonChange = function statefulButtonChange($el, state) {
  var stateClass = 'state-' + state;

  $el.spin(false)
    .removeClass('state-loading state-success state-error')
    .addClass(stateClass);

  setTimeout(function(){
    $el.removeClass(stateClass);
  }, 2000);
};
